import React from "react";
import { ContactForm } from "../../components/ContactForm/ContactForm";
import { SectionHeader } from "../../components/SectionHeader/SectionHeader";

const ContactUsPage: React.FC = () => {
  return (
    <div className="eh-page pt-header px-6 py-12 pb-16">
      <SectionHeader
        subtitle="Support"
        header="Contact us"
        description="Questions about registration, payments, or hosting an event? Our team is here to help."
      />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-8">
        <div className="lg:col-span-2 eh-card">
          <ContactForm />
        </div>

        <aside className="eh-card h-fit">
          <h2 className="font-semibold text-slate-900 mb-4">
            Other ways to reach us
          </h2>
          <div className="space-y-6 text-sm">
            <div>
              <p className="font-medium text-slate-700 mb-1">Email</p>
              <a
                href="mailto:contact@eventshouse.net"
                className="text-slate-800 underline underline-offset-2 hover:text-slate-600"
              >
                contact@eventshouse.net
              </a>
            </div>
            <p className="text-slate-600 leading-relaxed">
              We aim to reply within one business day. For urgent registration
              issues, include your event name and order reference in your
              message.
            </p>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default ContactUsPage;
